import type { Graph, TemplateTask } from "@lr-notitia/notitia-operator/schemas";
import { Ref, computed } from "vue";

export const templateTasks = (graph: Ref<Graph>) =>
	computed<TemplateTask[]>(
		() =>
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "task" && node.layer === "template"
			) as TemplateTask[]
	);
export function templateTask(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
	};
}

function byId(id: string, graph: Ref<Graph>): TemplateTask | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "task" && hit.layer === "template" ? (hit as TemplateTask) : undefined;
}
